import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "lib/i18n";

const LetsWorkTogether = () => {
  const { t } = useTranslation();
  return (
    <section className="lead">
      <div className="container text-center">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="lead-title text-white mb-5 mt-4">
              <h1 className="title-font">{t("lead.heading")}</h1>
              <p className="mt-4 mb-4 title-font-2">
                {t("lead.subheading")}
              </p>
              <Link to="/contact" className="btn cta-accent" role="button">
                {t("lead.cta")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetsWorkTogether;
